import { render, staticRenderFns } from "./AdverseIndividual.vue?vue&type=template&id=1c0f1be4&"
import script from "./AdverseIndividual.vue?vue&type=script&lang=js&"
export * from "./AdverseIndividual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports